import { validationTypes } from "../../../../components/forms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../../components/forms/libs/data/formFieldType";

const initState = {
  clientName: "",
  planName: "",
  planYearMonth: "",
  planYearDay: ""
};

export const addEditClientPlansFormConfig = {
  name: "Client Details",
  initialState: initState,
  section: [
    {
      sectionId: "basicDetailSection",
      title: "Basic Client Details",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-12",
      },
      wrapperTemplate: <div className="row row-gap"></div>,
      fields: [
        {
          id: "clientName",
          label: "Client",
          Field_Name: "client",
          fieldType: FormFieldTypes.INPUT,
          dataField: "clientName",
          fieldSetting: {
            placeholder: "Client Name",
            allowSpace: true,
            isDisable: true,
          },
          style: {
            containerCss: "col-lg-12 col-md-12",
          },
        },
        {
          id: "planName",
          label: "Plan Name",
          Field_Name: "plan name",
          fieldType: FormFieldTypes.INPUT,
          dataField: "planName",
          fieldSetting: {
            placeholder: "Please enter plan name",
            allowSpace: true,
            isDisable: false,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-12 col-md-12",
          },
        },
        {
          id: "planNumber",
          label: "Plan Number",
          Field_Name: "plan number",
          fieldType: FormFieldTypes.INPUT,
          dataField: "planNumber",
          fieldSetting: {
            placeholder: "Please enter plan number",
            allowSpace: true,
            isDisable: false,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-12 col-md-12",
          },
        },
        {
          id: "planYearMonth",
          label: "Plan Year Month",
          Field_Name: "plan year month",
          fieldType: FormFieldTypes.NUMERIC,
          dataField: "planYearMonth",
          fieldSetting: {
            placeholder: "Please enter plan year month",
            allowSpace: true,
            isDisable: false,
            max: 12,
            maxLength: 2
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-12 col-md-12",
          },
        },
        {
          id: "planYearDay",
          label: "Plan Year Day",
          Field_Name: "plan year day",
          fieldType: FormFieldTypes.NUMERIC,
          dataField: "planYearDay",
          fieldSetting: {
            placeholder: "Please enter plan year day",
            allowSpace: true,
            isDisable: false,
            max:31,
            maxLength: 2,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-12 col-md-12",
          },
        },


      ],
    },
  ],
};
